import { ThemeColors } from 'src/shared/styles/variables';
import styled from 'styled-components';

export const AddNewPermissionContainer = styled('div')`
  width: 448px;
  padding: 24px;
  padding-bottom: 0;


  h4 {
    margin-bottom: 0;
    font-family: var(--ds-font-stack-display-2-font-family)!important;
    font-weight: bold;
    font-size: 26px;
    line-height: 32px;
    color: ${ThemeColors.black};
    margin-bottom: 28px;
  }

 

  .panel-body{
    height: calc(100vh - 180px);
    overflow: auto;
  }

    .ln-c-progress-spinner{
      height: 25px;
      width: 25px;
      margin-right: 10px;
      color: ${ThemeColors.white};
    }
  }

  .feedback-container{

    position: relative;
    padding-top: 72px;

    .feedback-message{
      font-family: var(--ds-font-stack-display-2-font-family)!important;
      font-weight: bold;
      font-size: 40px;
      line-height: 50px;
      margin-bottom: 72px;
    }
  }
`;
